import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Image as ChakraImage } from '@chakra-ui/react';

const Media = ({ media, aria, image, ...rest }) => {
  const isGatsbyImage =
    typeof media?.localFile?.childImageSharp?.gatsbyImageData !== `undefined`;
  const gatsbyImage = media?.localFile?.childImageSharp?.gatsbyImageData;

  if (isGatsbyImage === false) {
    if (!media?.url && !image?.url) {
      return null;
    }
    return (
      <ChakraImage
        htmlwidth="100%"
        src={`${media?.url || image?.url}`}
        {...rest}
      />
    );
  }

  if (isGatsbyImage === true) {
    return (
      <ChakraImage
        htmlwidth="100%"
        as={GatsbyImage}
        image={gatsbyImage}
        alt={media.alternativeText || ``}
        {...rest}
      />
    );
  }

  return <ChakraImage src={image.src} alt={image.alt} />;
};

export default Media;
